import FormControl from '@mui/material/FormControl';
import Stack from '@mui/material/Stack';
import type { Option } from '@openx/types/options.ts';
import { useState } from 'react';
import { HierarchicalOption } from './HierarchicalOption.tsx';

type HierarchicalCheckboxSelectorProps = {
  selectedOptions: string[] | undefined;
  onOptionChange: (options: string | string[]) => void;
  isDisabled?: boolean;
  options?: Option[];
};

export const HierarchicalCheckboxSelector = ({
  options,
  selectedOptions,
  onOptionChange,
  isDisabled,
}: HierarchicalCheckboxSelectorProps) => {
  const selectedItems = selectedOptions || [];
  const [expanded, setExpanded] = useState<Set<string>>(new Set());

  return (
    <FormControl>
      <Stack
        spacing={1}
        sx={{
          alignItems: 'flex-start',
        }}
      >
        {options?.map(option => (
          <HierarchicalOption
            key={option.id}
            option={option}
            level={0}
            parentOption={undefined}
            selectedItems={selectedItems}
            onOptionChange={onOptionChange}
            isDisabled={isDisabled || option.disabled}
            expanded={expanded}
            setExpanded={setExpanded}
          />
        ))}
      </Stack>
    </FormControl>
  );
};
